import { useMediaQuery } from "@mui/material"
import WebManager from "./WebManagement"
import MobileManager from "./MobileManagement"
export default function Manager() {
    const isSmallScreen=useMediaQuery("(max-width:960px")
    return (
        isSmallScreen ? <MobileManager/> : <WebManager/>
    )
}